import { badge } from './util';

import { stackedChart } from './UI/highcharts/stacked-chart';
import { lineChart } from './UI/highcharts/line-chart';
import { getUnitUtil } from './get-unit-util';

import { productGroupHelper } from './product-group';

(function ($) {
	let showHideAddGroupByButton = function (disContent) {
		let currentSelects = disContent.find('select[name=group-by]');
		let addGroupByButton = disContent.find('.dis-13-add-group-by');

		if (currentSelects.length > 4) {
			addGroupByButton.hide();
		} else {
			addGroupByButton.show();
		}
	};

	let showHideCustomSettings = function (disContent) {
		if (disContent.find('input[name=usage]:checked').val() === 'custom') {
			disContent.find('.dis-custom-settings').show();
		} else {
			disContent.find('.dis-custom-settings').hide();
		}
	};

	$(document).on('click', '.dis-13-add-group-by', function () {
		let disContent = $(this).parents('.dis-content');
		let groupByTemplate = disContent.find('.groupby-select-in-template');
		let newGroupBy = groupByTemplate.clone().show().attr('id', '').removeClass('groupby-select-in-template');
		groupByTemplate.before(newGroupBy);
		showHideAddGroupByButton(disContent);
	});

	$(document).on('click', '.groupby-select-remove', function () {
		let disContent = $(this).parents('.dis-content');
		$(this).parents('.groupby-select-in').remove();
		showHideAddGroupByButton(disContent);
	});

	$(document).on('change', '.dis-content input[name=usage]', function () {
		let disContent = $(this).parents('.dis-content');
		showHideCustomSettings(disContent);
	});

	$('.dis-content').each(function () {
		let disContent = $(this);
		showHideAddGroupByButton(disContent);
		showHideCustomSettings(disContent);
	});
})(jQuery);

/**
 * Features of product group detail.
 */
var productGroupDisDetail = (function ($) {
	var root;

	var init = function () {
		root = $('.product-dis-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.btn-cancel').click(cancelChangeFilters);
		root.find('.btn-edit').click(openSearchForm);
		$(document).on('productGroup.created', saveProductGroupFilters);
	};

	var openSearchForm = function () {
		root.find('.product-group-edit-close').hide();
		root.find('.product-group-edit-open').show();
		cloneSearchFormContainer();
	};

	var cloneSearchFormContainer = function () {
		// Clone the search form, so it is possible to cancel all changes with cancel button.
		// There is a problem with copying state of selects, so 'selected' attributed needs to be set.
		var originalSearchFormContainer = root.find('.search-form-container');
		originalSearchFormContainer.find('select').each(setOptionsSelectedAttribute);

		var searchFormContainer = originalSearchFormContainer.clone(true);
		root.find('.product-group-search-form').prepend(searchFormContainer);

		// Initialize the search form.
		searchFormContainer.show();
		searchFormContainer.searchForm();

		root.find('.btn-create-product-group').createProductGroupModal('.create-product-group-modal');
	};

	/**
	 * Save product group filters when product group has been created.
	 *
	 * @param {object} event Event data.
	 * @param {{
	 *	 productGroup: {
	 *		 id: string,
	 *		 type: string,
	 *		 name: string,
	 *		 notification: {
	 *			 settings: {
	 *				 frequency: string
	 *			 }
	 *		 },
	 *		 productsCount:int
	 *	 }
	 * }} response Data returned from the server.
	 */
	var saveProductGroupFilters = function (event, response) {
		productGroupHelper.createSaveFiltersApiRequest(response.productGroup.id).done(function () {
			productGroupHelper.redirectToProductGroupDetail(event, response);
		});
	};

	var setOptionsSelectedAttribute = function () {
		$(this)
			.find('option')
			.each(function () {
				$(this).attr('selected', $(this).is(':selected'));
			});
	};

	var cancelChangeFilters = function () {
		// Remove the search form which has been cloned in the openSearchForm function and this way
		// effectively discard all changes in product group filters which should not be saved.
		var containers = root.find('.product-group-search-form .search-form-container');

		if (containers.length > 1) {
			containers.first().remove();
		}

		// Close the search form.
		closeSearchForm();
	};

	var closeSearchForm = function () {
		hideSearchFormContainer();
		root.find('.product-group-edit-open').hide();
		root.find('.product-group-edit-close').show();
	};

	var hideSearchFormContainer = function () {
		var searchFormContainer = root.find('.product-group-edit-open .search-form-container');
		searchFormContainer.searchForm('destroy');
		searchFormContainer.hide();
		badge.hide(root.find('.buttons .badge'));
	};

	return {
		init: init,
	};
})(jQuery);

function disChart() {
	if (!window.disChartData) {
		return;
	}

	var dates = window.disChartData.chartFlatPoints.reduce(function (result, point) {
		result[point.date] = {};
		return result;
	}, {});

	var sortedDates = Object.keys(dates);
	sortedDates.sort(function (a, b) {
		return Number(new Date(a)) - Number(new Date(b));
	});

	var byDate = window.disChartData.chartFlatPoints.reduce(function (result, point) {
		if (!result[point.date]) {
			result[point.date] = {};
		}
		result[point.date][point.name] = point.value;
		return result;
	}, {});

	var byName = Object.keys(byDate).reduce(function (result, date) {
		var sum = Object.values(byDate[date]).reduce(function (sum, value) {
			return sum + Math.abs(value);
		}, 0);

		Object.keys(byDate[date]).forEach(function (name, i) {
			if (!result[name]) {
				result[name] = {
					name: name,
					values: Object.assign({}, dates),
				};
			}
			result[name].values[date] = {
				value: byDate[date][name],
				percentage: (100 / sum) * byDate[date][name],
			};
		});
		return result;
	}, {});

	var data = Object.values(byName);
	var lastDate = sortedDates[sortedDates.length - 1];
	data.sort(function (a, b) {
		return b.values[lastDate].value - a.values[lastDate].value;
	});

	var periodQuarter = /period=quarter/.test(window.location.search);
	var intlDateFormatter = Intl.DateTimeFormat('cs-CZ', {
		month: periodQuarter || /period=year/.test(window.location.search) ? undefined : 'long',
		year: 'numeric',
	});
	var dateFormatter = function (date) {
		return (periodQuarter ? `Q${Math.round((date.getMonth() + 1) / 4) + 1} ` : '') + intlDateFormatter.format(date);
	};

	const name = window.disName || '';
	const subtitle = window.disSubtitle || '';
	const exportFilename = window.exportFilename || 'lp-distribution';
	const yAxisName = getUnitUtil({ omitUnit: window.disChartType === 'ONE_HUNDRED_CHART' }) || '';

	switch (window.disChartType) {
		case 'STACKED_GRAPH':
			disStackedChart(sortedDates, data, false, dateFormatter, {
				name: name,
				subtitle: subtitle,
				exportFilename,
				// @ts-expect-error: automatically injected
				unit: typeof window.chartUnit !== 'undefined' ? window.chartUnit : '',
				yAxisName: window.yAxisName || yAxisName,
			});
			break;

		case 'LINE_CHART':
			disLineChart(sortedDates, data, dateFormatter, {
				name: name,
				subtitle: subtitle,
				exportFilename,
				// @ts-expect-error: automatically injected
				unit: typeof window.chartUnit !== 'undefined' ? window.chartUnit : '',
				yAxisName: window.yAxisName || yAxisName,
			});
			break;

		case 'ONE_HUNDRED_CHART':
			disStackedChart(sortedDates, data, true, dateFormatter, {
				name: name,
				subtitle: subtitle,
				exportFilename,
				// @ts-expect-error: automatically injected
				unit: typeof window.chartUnit !== 'undefined' ? window.chartUnit : '\u00A0%',
				yAxisName: window.yAxisName || yAxisName,
			});
			break;
	}
}

const disStackedChart = (labels, data, percentage, dateFormatter, options = {}) => {
	if (labels.length === 0) {
		jQuery('#high-chart').append('<h3 class="text-center">Chybí data</h3>');
		return null;
	}

	return stackedChart(labels, data, percentage, dateFormatter, 'high-chart', options);
};

const disLineChart = (labels, data, dateFormatter, options = {}) => {
	if (labels.length === 0) {
		jQuery('#high-chart').append('<h3 class="text-center">Chybí data</h3>');
		return null;
	}

	return lineChart(labels, data, dateFormatter, 'high-chart', options);
};

export { productGroupDisDetail, disChart, disStackedChart, disLineChart };
